'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixQuoteMediaMarketMovers is a web component
     * responsible for loading market movers on marketing Page
     *
     * @example
     *  <phoenix-quote-media-market-movers>
     *  </phoenix-quote-media-market-movers>
     */
    class PhoenixQuoteMediaMarketMovers extends pageClass.PhoenixElement {
        // web component life cycle hook
        connectedCallback() {
            super.connectedCallback();
            const config = {
                lang: 'en',
                stats: 'va,dg,dl',
                exchanges: 'NYE,AMX,NSD,OTO',
                statTop: 5,
                marketSession: 'NORMAL',
                defaultExchange: 'NYE',
                showExchanges: true,
                showSectors: false,
                showType: false,
                showHours: false,
                collapsedHeight: 670,
                tooltip: true,
                colVis: 'true,true,true,true,true,true,true,true,true,true,true,true',
                modalParams: {
                    chfill: 'eeeeee',
                    chfill2: '0071bb',
                    chln: '00578e',
                    chscale: '1y',
                    chcon: 'on',
                    chfrmon: 'off',
                    chtype: 'line',
                    chbgch: 'ffffff',
                    chgrd: 'cccccc',
                    chbdr: 'cccccc',
                    chxyc: '666666',
                    chdon: 'off',
                    chton: 'off',
                    chhig: '240',
                    chfnts: '10',
                },
                symbolForwardURL: 'https://www.thestreet.com/quote/',
                longNameForwardURL: 'https://www.thestreet.com/quote/',
            };
            this._render(config);
        }

        _render(config) {
            let qmodConfig = JSON.stringify(config);
            this.innerHTML = `<div data-qmod-tool="marketmovers"
            data-qmod-params=${qmodConfig} class="qtool has-forwardurl"></div>`;
        }
    }

    window.customElements.define('phoenix-quote-media-market-movers', PhoenixQuoteMediaMarketMovers);
});
